import { Link } from "wouter";
import { AlertCircle, Home } from "lucide-react";

export default function NotFound() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--cc-gray-50)", fontFamily: "var(--cc-font)" }}>
      <div style={{ background: "white", border: "1px solid var(--cc-gray-200)", borderRadius: 14, padding: 40, maxWidth: 460, textAlign: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
          <div style={{ width: 56, height: 56, borderRadius: "50%", background: "var(--cc-amber-bg)", color: "var(--cc-amber)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <AlertCircle size={28} />
          </div>
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, color: "var(--cc-navy)", marginBottom: 4 }}>Página no encontrada</div>
        <div style={{ fontSize: 13, color: "var(--cc-gray-600)", marginBottom: 18 }}>La ruta que buscas no existe en la demo.</div>
        <Link href="/" data-testid="link-home" style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "10px 18px", background: "linear-gradient(135deg, var(--cc-navy), var(--cc-teal))", color: "white", borderRadius: 8, textDecoration: "none", fontSize: 13, fontWeight: 600 }}>
          <Home size={14} /> Volver a la portada
        </Link>
      </div>
    </div>
  );
}
